import {
  Alert,
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import { EntityWithIdFields } from 'src/types';
import CardActions from '../../../components/CardActions';
import { useLCSLHPTITablaValor } from '../hooks/useLCSLHPTITablaValor';
import { OperacionLCSLHPTITablaValorFields } from '../types/fields';
import { OperacionLCSLHPTI } from '../types/types';

interface SeccionLCSLHPTITablaValoresProps {
  operacion: OperacionLCSLHPTI;
}

const SeccionLCSLHPTITablaValores = ({ operacion }: SeccionLCSLHPTITablaValoresProps) => {
  const idOperacion = operacion[EntityWithIdFields.Id];

  const {
    groupedHeaders,
    rows,
    isLoading,
    isError,
    error
  } = useLCSLHPTITablaValor(idOperacion);

  return (
    <CardActions title="Matriz de Límites y Condiciones" icon='mdi:table-check' colapsable tableContent>
      {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
          <CircularProgress size={24} />
          <Typography sx={{ ml: 2 }}>Cargando matriz...</Typography>
        </Box>
      ) : isError ? (
        <Box sx={{ px: 4, py: 3 }}>
          <Alert severity="error">{error?.message || 'Error al cargar los datos de limites'}</Alert>
        </Box>
      ) : (
      <TableContainer component={Paper} variant="outlined" sx={{ mt: 1 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell
                align="center"
                sx={{ backgroundColor: 'grey.100', fontWeight: 'bold', borderRight: 1, borderColor: 'divider' }}
              >
                Instrumento
              </TableCell>
              {groupedHeaders.map((group) => (
                <TableCell
                  key={group.agrupacion}
                  align="center"
                  colSpan={group.columnas.length}
                  sx={{ backgroundColor: 'grey.100', fontWeight: 'bold', borderRight: 1, borderColor: 'divider' }}
                >
                  {group.agrupacion}
                </TableCell>
              ))}
            </TableRow>

            <TableRow>
              <TableCell sx={{ borderRight: 1, borderColor: 'divider', backgroundColor: 'grey.50' }} />
              {groupedHeaders.flatMap(group =>
                group.columnas.map(col => (
                  <TableCell
                    key={col.codOperacionTipo}
                    align="center"
                    sx={{ fontWeight: 'medium', fontSize: '0.75rem', borderRight: 1, borderColor: 'divider', minWidth: 100 }}
                  >
                    {col.descOperacionTipo}
                  </TableCell>
                ))
              )}
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.map((row) => (
              <TableRow
                key={row.rowKey}
                hover>
                <TableCell
                  sx={{ fontWeight: 'bold', backgroundColor: 'grey.50', borderRight: 1, borderColor: 'divider' }}
                >
                  {row.descInstrumento}
                </TableCell>
                {groupedHeaders.flatMap(group =>
                  group.columnas.map(col => {
                    const celda = row.celdas[col.codOperacionTipo];

                    return (
                      <TableCell
                        key={`${row.codInstrumento}-${col.codOperacionTipo}`}
                        align="center"
                        sx={{ borderRight: 1, borderColor: 'divider' }}
                      >
                        <Typography variant="body2">
                          {celda[OperacionLCSLHPTITablaValorFields.Valor]}
                        </Typography>
                      </TableCell>
                    );
                  })
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      )}
    </CardActions>
  );
};

export default SeccionLCSLHPTITablaValores;